exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".RoundedImageIcon__roundedImageIcon___2prwz {\n\tborder-radius: 50%;\n\twidth: 4rem;\n\theight: 4rem;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tbackground-position: center;\n\tflex-shrink: 0;\n}\n\n.RoundedImageIcon__cover___1zszM {\n\tbackground-size: cover;\n}\n", ""]);

// exports
exports.locals = {
	"roundedImageIcon": "RoundedImageIcon__roundedImageIcon___2prwz",
	"cover": "RoundedImageIcon__cover___1zszM"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/RoundedImageIcon.icss
// module id = 1253
// module chunks = 0